/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { setCurrentTool, setIs3DModeEnabled, setIsMPRModeEnabled, setShowHistory } from '../../../../../actions/LayoutActions';
import store from '../../../../../store/store';
import { changePatientToAnonym } from '../../../../../actions/ConfigActions';
import { ButtonGroup } from '../../../Common/styled/Button';
import { CommonButtons, CreateButton, CreateToggleButton, CreateOptionsButton, AcknowledgeButton, LogoutButton } from '../../../Header/Toolbar/ToolbarButtons';
import { getToolset3D } from '../../../Header/Toolbar/getToolset3D';
import { getVolumeManager, to3DLibraryToolName } from '../../getVolumeManager';
import useKeypressTools from '../../../../../util/useKeypressTools';
import { screenShot3D, captureScreenShot3D, downloadScreenShot3D } from '../../../../../util/takeScreenShot';
import toolNames from '../../../Header/Toolbar/toolNames';
import {
  setLayout2DMode,
  setLayout3DMode,
  setLayout3DModeMobile,
  setLayoutMPRMode,
  setLayoutMPRModeMobile,
} from '../../Layout/LayoutUtils';
import { CaptureDownloadDialog } from '../../../Common/CaptureDownloadDialog';
import GroupedTools from '../../../Header/Toolbar/GroupedTools';
import {
  executeOnActiveViewport,
  getCrossWindowActiveViewport,
  getCrossWindowWindowId,
} from '../../crossWindow2dReferenceLines';

export const toolbar3d = ({ currentLayoutElement, config, layout }) => {
  const volumeManager3d = getVolumeManager();
  const [groupedTools, setGroupedTools] = useState(null);
  const [groupedToolsXPosition, setGroupedToolsXPosition] = useState(null);
  const [groupedToolsYPosition, setGroupedToolsYPosition] = useState(null);
  const [groupedToolsButtonTopPosition, setGroupedToolsButtonTopPosition] = useState(null);
  const [openGroupedToolsName, setOpenGroupedToolsName] = useState(null);
  const [showCaptureDownload, setShowCaptureDownload] = useState(false);
  const [referenceLinesVisible, setReferenceLinesVisible] = useState(() => {
    const activeViewport = getCrossWindowActiveViewport();
    if (activeViewport?.windowId !== getCrossWindowWindowId()
      && typeof activeViewport?.referenceLinesVisible === 'boolean') {
      return activeViewport.referenceLinesVisible;
    }
    const mprViews = volumeManager3d?.all_views?.filter((view) => view.appFlagsObj.viewType === 'mpr') || [];
    return mprViews.length === 0 || mprViews.every((view) => view.options.axisIntersectionLinesEnabled !== false);
  });
  useEffect(() => {
    const handleActiveViewportChange = (event) => {
      const activeViewport = event.detail;
      if (activeViewport?.windowId !== getCrossWindowWindowId()
        && typeof activeViewport?.referenceLinesVisible === 'boolean') {
        setReferenceLinesVisible(activeViewport.referenceLinesVisible);
      } else if (activeViewport?.windowId === getCrossWindowWindowId()) {
        const localMprViews = getVolumeManager()?.all_views?.filter(
          (view) => view.appFlagsObj.viewType === 'mpr'
        ) || [];
        setReferenceLinesVisible(localMprViews.length === 0
          || localMprViews.every((view) => view.options.axisIntersectionLinesEnabled !== false));
      }
    };
    window.addEventListener('viewer-active-viewport-changed', handleActiveViewportChange);
    return () => window.removeEventListener('viewer-active-viewport-changed', handleActiveViewportChange);
  }, []);
  const toolset3D = getToolset3D(layout);
  const annotationOptions = toolset3D.find((tool) => tool.name === toolNames.ANNOTATIONS)?.options || [];
  const currentToolbarTool = annotationOptions.some((tool) => tool.name === layout.currentTool)
    ? toolNames.ANNOTATIONS
    : layout.currentTool;
  const deactivateAnnotationEraser = () => {
    if (!volumeManager3d?.annotationEraserMode) return;

    volumeManager3d.annotationEraserMode = false;
    volumeManager3d.annotationEraserPreviousTool = undefined;
  };
  const handlerSelectTool = (tool) => {
    const activeViewport = getCrossWindowActiveViewport();
    const isRemoteViewportActive = activeViewport
      && activeViewport.windowId !== getCrossWindowWindowId();
    if (isRemoteViewportActive && tool.name === toolNames.CLIPPING) {
      executeOnActiveViewport(tool.name, layout.selectedViewIndex);
      store.dispatch(setCurrentTool(tool.name));
      return;
    }
    if (isRemoteViewportActive && tool.name === toolNames.REF_LINES) {
      executeOnActiveViewport(tool.name, layout.selectedViewIndex);
      return;
    }
    if (isRemoteViewportActive && [toolNames.COPY_CAPTURE, toolNames.DOWNLOAD_CAPTURE].includes(tool.name)) {
      executeOnActiveViewport(tool.name, layout.selectedViewIndex);
      return;
    }
    if (isRemoteViewportActive && (
      tool.name === toolNames.PALETTE_VR
      || [
        toolNames.GREYSCALE,
        toolNames.BONEPALETTE,
        toolNames.AIRBONEPALETTE,
        toolNames.AIRPALETTE,
        toolNames.REDPALETTE,
        toolNames.FIREPALETTE,
        toolNames.ICEPALETTE,
        toolNames.RAINBOWPALETTE,
      ].includes(tool.name)
    )) {
      executeOnActiveViewport(tool.name, layout.selectedViewIndex, {
        paletteType: tool.name === toolNames.PALETTE_VR ? 'vr' : 'mpr',
        paletteName: tool.name === toolNames.PALETTE_VR ? tool.paletteName : tool.name,
      });
      return;
    }
    if (
      [toolNames.MODE_2D, toolNames.MODE_MPR, toolNames.MODE_3D].includes(tool.name)
      && activeViewport?.windowId !== getCrossWindowWindowId()
    ) {
      executeOnActiveViewport(tool.name, layout.selectedViewIndex);
      return;
    }
    if (
      tool.name !== toolNames.HISTORY
      && tool.name !== toolNames.CROSS_REFERENCE
      && tool.name !== toolNames.REF_LINES
      && tool.name !== toolNames.ERASER
      && tool.name !== toolNames.ROTATE_MENU
      && tool.name !== toolNames.ZOOM_MENU
      && layout.currentTool === tool.name
    ) return;

    if ([
      toolNames.ROTATE90,
      toolNames.ROTATE270,
      toolNames.HFLIP,
      toolNames.VFLIP,
      toolNames.RESET_POSITION,
      toolNames.ZOOM_1_TO_1,
      toolNames.ZOOM_FIT,
      toolNames.ZOOM_ACTUAL_SIZE,
    ].includes(tool.name)) {
      executeOnActiveViewport(tool.name, layout.selectedViewIndex);
      return;
    }

    switch (tool.name) {
      case toolNames.ROTATE_MENU: {
        if (!volumeManager3d) return;
        deactivateAnnotationEraser();
        volumeManager3d.changeTool('rotation', 'left', undefined);
        store.dispatch(setCurrentTool(toolNames.ROTATE));
        handleGroupedTools(tool);
        break;
      }
      case toolNames.ZOOM_MENU: {
        if (!volumeManager3d) return;
        deactivateAnnotationEraser();
        volumeManager3d.changeTool('zoom', 'left', undefined);
        store.dispatch(setCurrentTool(toolNames.ZOOM));
        break;
      }
      case toolNames.ROTATE:
        if (!volumeManager3d) return;
        deactivateAnnotationEraser();
        volumeManager3d.changeTool('rotation', 'left', undefined);
        store.dispatch(setCurrentTool(toolNames.ROTATE));
        break;
      case toolNames.RESET:
        if (!volumeManager3d) return;
        volumeManager3d.api.resetAll(true);
        break;
      case toolNames.PALETTES_VR: 
      case toolNames.PALETTES: 
        break;
      case toolNames.PALETTE_VR:
        changePaletteVR(tool.paletteName);
        break;
      case toolNames.GREYSCALE:
      case toolNames.BONEPALETTE:
      case toolNames.AIRBONEPALETTE:
      case toolNames.AIRPALETTE:
      case toolNames.REDPALETTE:
      case toolNames.FIREPALETTE:
      case toolNames.ICEPALETTE:
      case toolNames.RAINBOWPALETTE:
        changePaletteMPR(tool.name);
        break;

      case toolNames.COPY_CAPTURE:
        screenShot3D();
        break;

      case toolNames.DOWNLOAD_CAPTURE:
        setShowCaptureDownload(true);
        break;

      case toolNames.ANONYMIZE:
        store.dispatch(changePatientToAnonym());
        break;

      case toolNames.INTENSITY:
        break;

      case toolNames.INTENSITY_PROJECTION:
        changeIntensityProjection(parseInt(tool.value, 10));
        break;

      case toolNames.MODE_2D:
        if (layout.isMPRModeEnabled) {
          deactivateAnnotationEraser();
          store.dispatch(setCurrentTool(toolNames.WWWC));
        }
        setLayout2DMode(currentLayoutElement);
        break;

      case toolNames.MODE_3D:
        deactivateAnnotationEraser();
        store.dispatch(setIsMPRModeEnabled(false));
        store.dispatch(setIs3DModeEnabled(true));
        if (isMobile) {
          setLayout3DModeMobile(currentLayoutElement);
        } else {
          setLayout3DMode(currentLayoutElement);
        }
        break;

      case toolNames.MODE_MPR:
        deactivateAnnotationEraser();
        store.dispatch(setIs3DModeEnabled(false));
        store.dispatch(setIsMPRModeEnabled(true));
        if (isMobile) {
          setLayoutMPRModeMobile(currentLayoutElement);
        } else {
          setLayoutMPRMode(currentLayoutElement);
        }
        store.dispatch(setCurrentTool(toolNames.CROSS_REFERENCE));
        break;

      case toolNames.CROSS_REFERENCE:
        if (volumeManager3d === undefined) return;
        deactivateAnnotationEraser();
        const referenceViews = volumeManager3d.all_views.filter(
          (view) => view.appFlagsObj
        );
        if (layout.currentTool === toolNames.CROSS_REFERENCE) {
          const markersVisible = referenceViews.some(
            (view) => view.appFlagsObj.drawCrossRefLines !== false
          );
          referenceViews.forEach((view) => {
            view.appFlagsObj.drawCrossRefLines = !markersVisible;
            view.appFlagsObj.useChangeProxyGeometry('toolbar3d.toggleCrossRefMarkers');
          });
        } else {
          referenceViews.forEach((view) => {
            view.appFlagsObj.drawCrossRefLines = true;
            view.appFlagsObj.useChangeProxyGeometry('toolbar3d.showCrossRefMarkers');
          });
          volumeManager3d.changeTool('crossRef', 'left');
          store.dispatch(setCurrentTool(tool.name));
        }
        break;

      case toolNames.REF_LINES: {
        if (volumeManager3d === undefined) return;
        const enabled = !referenceLinesVisible;
        volumeManager3d.all_views.forEach((view) => {
          if (view.appFlagsObj.viewType === 'mpr') {
            view.options.axisIntersectionLinesEnabled = enabled;
            view.appFlagsObj.useChangeProxyGeometry('toolbar3d.toggleReferenceLines');
          }
        });
        setReferenceLinesVisible(enabled);
        break;
      }

      case toolNames.CLEAR_ANNOTATIONS:
        if (volumeManager3d === undefined) return;
        volumeManager3d.annotations.slice().forEach(({ annotation }) => {
          volumeManager3d.deleteAnn(annotation);
        });
        break;

      case toolNames.ERASER:
        if (volumeManager3d?.areAnnotationsSelected()) {
          volumeManager3d.annotationEraserMode = false;
          volumeManager3d.annotationEraserPreviousTool = undefined;
          volumeManager3d.deleteSelectedAnnotations();
        } else if (volumeManager3d?.annotationEraserMode) {
          volumeManager3d.annotationEraserMode = false;
          const previousTool = volumeManager3d.annotationEraserPreviousTool || toolNames.CROSS_REFERENCE;
          volumeManager3d.annotationEraserPreviousTool = undefined;
          store.dispatch(setCurrentTool(previousTool));
        } else if (volumeManager3d) {
          volumeManager3d.annotationEraserPreviousTool = layout.currentTool;
          volumeManager3d.annotationEraserMode = true;
          store.dispatch(setCurrentTool(toolNames.ERASER));
        }
        break;

      case toolNames.HISTORY:
        store.dispatch(setShowHistory(!store.getState().layout.showHistory));
        break;

      default:
        if (volumeManager3d === undefined) return;
        deactivateAnnotationEraser();
        if (tool.mprAnnotationName) {
          volumeManager3d.changeAnnotationMode(
            tool.mprAnnotationName,
            undefined,
            'left',
            volumeManager3d.lastTool
          );
          store.dispatch(setCurrentTool(tool.name));
          break;
        }
        volumeManager3d.changeTool(to3DLibraryToolName(tool.name), 'left', undefined);
        store.dispatch(setCurrentTool(tool.name));
        break;
    }
  };

  const defaultProps = {
    currentTool: currentToolbarTool,
    handlerSelectTool,
    currentLayoutElement,
  };

  const handleGroupedTools = (tool) => {
    if (openGroupedToolsName !== tool.name) {
      const buttonBounds = tool.elementRef.current.getBoundingClientRect();
      setGroupedToolsXPosition(buttonBounds.x);
      setGroupedToolsYPosition(buttonBounds.bottom);
      setGroupedToolsButtonTopPosition(buttonBounds.top);
      setGroupedTools(tool.groupedTools);
      setOpenGroupedToolsName(tool.name);
    } else {
      setGroupedTools(null);
      setOpenGroupedToolsName(null);
    }
  };

  const closeGroupedTools = (tools) => {
    setGroupedTools(tools);
    if (!tools) setOpenGroupedToolsName(null);
  };

  const changePaletteMPR = (palette) => {
    const volumeManager3d = getVolumeManager();
    if (volumeManager3d === undefined) return;

    for (let itView = 0; itView < volumeManager3d.all_views.length; itView++) {
      const view = volumeManager3d.all_views[itView];

      if (view.appFlagsObj.viewType === 'mpr') {
        const showBar = true;
        const setWLWCAllRanges = true;
        view.mprState.setPalette(palette, showBar, setWLWCAllRanges);
      }
    }
  };

  const changePaletteVR = (palette) => {
    const volumeManager3d = getVolumeManager();
    if (volumeManager3d === undefined) return;

    for (let itView = 0; itView < volumeManager3d.all_views.length; itView++) {
      const view = volumeManager3d.all_views[itView];

      if (view.appFlagsObj.viewType === 'vr') {
        view.usePalette(palette, true);
      }
    }
  };  
  
  const changeIntensityProjection = (value) => {
    const volumeManager3d = getVolumeManager();
    if (volumeManager3d === undefined) return;

    volumeManager3d.api.setMPRMode(value);
  }

  
  useKeypressTools(toolset3D, handlerSelectTool);

  return (
    <>
      {groupedTools && (
        <GroupedTools
          tools={groupedTools}
          setGroupedTools={closeGroupedTools}
          groupedToolsXPosition={groupedToolsXPosition}
          groupedToolsYPosition={groupedToolsYPosition}
          groupedToolsButtonTopPosition={groupedToolsButtonTopPosition}
          currentTool={layout.currentTool}
          selectedElement={layout.elements[layout.selectedViewIndex]}
          handlerSelectTool={handlerSelectTool}
        />
      )}
      <ButtonGroup key="group">
        <CommonButtons config={config} layout={layout}/>
        {toolset3D.map((tool, i) => {
        if (tool.name === toolNames.ROTATE_MENU) {
          return <CreateButton key={`${tool.name}${i}`} tool={tool} {...defaultProps} isEnabledTool={layout.currentTool === toolNames.ROTATE ? tool.name : undefined} />;
        }
        if (tool.name === toolNames.REF_LINES) {
          return <CreateButton key={`${tool.name}${i}`} tool={tool} {...defaultProps} currentTool={undefined} isEnabledTool={referenceLinesVisible ? tool.name : undefined} />;
        }
        switch (tool.type) {
          case 'button':
            return <CreateButton key={`${tool.name}${i}`} tool={tool} {...defaultProps} />;
          case 'toggle':
            return <CreateToggleButton key={`${tool.name}${i}`} tool={tool} {...defaultProps} />;
          case 'options': {
            const resolvedOptions = typeof tool.options === 'function' ? tool.options() : tool.options;
            if (!resolvedOptions || resolvedOptions.length === 0) {
              return null;
            }
            return <CreateOptionsButton key={`${tool.name}${i}`} tool={tool} {...defaultProps} />;
          }
          default:
            return <>{console.log('tool type is not correct')}</>;
        }
        })}
        <AcknowledgeButton config={config} />
        <LogoutButton />
      </ButtonGroup>
      <CaptureDownloadDialog
        open={showCaptureDownload}
        onClose={() => setShowCaptureDownload(false)}
        getCapture={captureScreenShot3D}
        onSubmit={downloadScreenShot3D}
      />
    </>
  );
};
